var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import uuid from 'uuid/v4';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '../FormControl/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import CalendarIcon from '@ellucian/ds-icons/lib/Calendar';
import { withEDSContext } from '../EDSContext/EDSContext';

import { DateUtils } from 'react-day-picker';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';

import DayPicker, { FIRST_SELECTABLE_DAY, FIRST_DAY_IN_MONTH, CURRENT_DATE } from '../DayPicker/DayPicker';
import Typography from '../Typography';

import { withStyles } from '@ellucian/react-design-system/core/styles';
import styles from './styles/styles';

import { getDefaultMaxDate, getDefaultMinDate } from '../DayPicker/internal/DateUtils';

/**
 * Use `DatePicker` to select a single date.
 * @done false
 * @updated true
 * @versionAdded v5.2.0
 * @lab true
 * @examples
 *  DatePickerExample
 *  DatePickerDisabled
 *  DatePickerRequired
 *  DatePickerMonthYearSelector
 *  DatePickerStandalone
 *  DatePickerFlipPosition
 */

var DatePicker = function (_React$Component) {
    _inherits(DatePicker, _React$Component);

    function DatePicker(props, context) {
        _classCallCheck(this, DatePicker);

        // Function bindings
        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props, context));

        _initialiseProps.call(_this);

        _this.handleOnDayClick = _this.handleOnDayClick.bind(_this);
        _this.openDatePicker = _this.openDatePicker.bind(_this);
        _this.closeDatePicker = _this.closeDatePicker.bind(_this);
        _this.handleInputBlur = _this.handleInputBlur.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleInputClick = _this.handleInputClick.bind(_this);
        _this.handleDayMouseEnter = _this.handleDayMouseEnter.bind(_this);
        _this.handleDayMouseLeave = _this.handleDayMouseLeave.bind(_this);
        _this.handleContainerKeyDown = _this.handleContainerKeyDown.bind(_this);

        _this.getInputDisplayString = _this.getInputDisplayString.bind(_this);

        // Refs
        _this.inputContainerRef = React.createRef();
        _this.inputRef = React.createRef();
        _this.datepicker = React.createRef();

        _this.state = _this.initialState();

        _this.uuid = uuid();
        return _this;
    }

    // ******
    // Initializations
    // ******


    _createClass(DatePicker, [{
        key: 'initialState',
        value: function initialState() {
            var value = this.getInitialDate();
            var isOpen = this.getInitialOpenState();

            return {
                isOpen: isOpen,

                // Helper util variables to keep track of focus states
                isInputFocused: false,
                wasLastFocusChangeDueToSelectingDate: false,

                // Used to show the input value string when user is typing in the input field
                inputString: '',

                // Used to show the user the date they are hovering over when calendar UI is open
                hoverString: null,

                // The day picked
                value: value
            };
        }
    }, {
        key: 'componentDidUpdate',


        // ******
        // Lifecycle Methods
        // ******
        value: function componentDidUpdate(prevProps) {
            if (this.state.wasLastFocusChangeDueToSelectingDate && this.props.variant === 'text-field') {
                this.inputRef.current.focus();
            }

            // If values change for controlled implementations, update internal component with new date values
            if (this.props.value !== prevProps.value) {
                var value = this.props.value;
                this.setState({ value: value });
            }
        }

        // ******
        // Helper functions
        // ******

    }, {
        key: 'getInputDisplayString',
        value: function getInputDisplayString(locale) {
            var _state = this.state,
                isInputFocused = _state.isInputFocused,
                inputString = _state.inputString,
                hoverString = _state.hoverString,
                value = _state.value;


            if (hoverString != null) {
                // Show hover string as priority
                return hoverString;
            } else if (isInputFocused) {
                // If Input is focused, then show inputString being typed in
                return inputString == null ? '' : inputString;
            } else if (value == null) {
                // if value is empty, show empty string
                return '';
            } else {
                // if no issues, get formatted date string and display
                return this.getFormattedDateString(value, this.props, locale);
            }
        }

        // ========
        // DayPicker functions
        // ========

    }, {
        key: 'handleDayMouseEnter',
        value: function handleDayMouseEnter(day) {
            var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var locale = arguments[2];

            // If the mouse enters a day (or the calendar),
            // show the 'potential' date
            this.setState({
                hoverString: formatDate(day, this.props.format, locale)
            });
        }
    }, {
        key: 'handleDayMouseLeave',
        value: function handleDayMouseLeave(day) {
            // If the mouse leaves a day (or the calendar),
            // The original inputString should show after mouse leaves day element
            this.setState({
                hoverString: null
            });
        }
    }, {
        key: 'handleOnDayClick',
        value: function handleOnDayClick(day) {
            var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var e = arguments[2];

            // You should never receive a day when it is disabled because of shared code

            var nextState = {};

            if (day != null) {
                nextState = Object.assign({}, nextState, {
                    value: day,
                    isOpen: false,
                    hoverString: null,
                    wasLastFocusChangeDueToSelectingDate: true
                });
                // set internal state only if a day is received
                this.setState(nextState);
            }

            // send controlled values to onChange method
            if (this.isControlled() && this.props.onChange) {
                this.props.onChange(day, modifiers, e);
            }
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e, locale) {

            var currentInputString = e.target.value;
            var isValueControlled = this.isControlled();
            var maybeNextDate = this.parseDate(currentInputString, locale);

            var nextState = { isOpen: true };

            // If no text is in the input field, then return null
            if (currentInputString.length === 0) {
                var baseState = Object.assign({}, nextState, {
                    inputString: ''
                });
                if (isValueControlled) {
                    nextState = baseState;

                    if (this.props.onChange) {
                        // reset respective input field's value
                        this.props.onChange(null);
                    }
                } else {
                    nextState = Object.assign({}, baseState, { value: null });
                }
            } else if (DateUtils.isDate(maybeNextDate)) {
                // If the date typed in is valid,
                // through into this block so that the UI can update immediately, possibly with an error
                // message on the other field.
                // also, clear the hover string to ensure the most recent keystroke appears.
                var _baseState = Object.assign({}, nextState, {
                    hoverString: null,
                    inputString: currentInputString
                });
                if (isValueControlled) {
                    nextState = _baseState;
                    if (this.props.onChange) {
                        this.props.onChange(maybeNextDate);
                    }
                } else {
                    nextState = Object.assign({}, _baseState, {
                        value: maybeNextDate
                    });
                }
            } else {
                // User is typing a date so update the inputString
                nextState = Object.assign({}, nextState, {
                    inputString: currentInputString,
                    hoverString: null
                });
            }

            // Update state
            this.setState(nextState);
        }
    }, {
        key: 'handleInputBlur',
        value: function handleInputBlur(e, locale) {
            var value = e.target.value;
            var inputString = this.state.inputString;


            var maybeNextDate = this.parseDate(inputString, locale);
            var isValueControlled = this.isControlled();

            var nextState = {
                isInputFocused: false,
                wasLastFocusChangeDueToSelectingDate: false
            };

            // if input is empty, then update inputString value to ""
            if (this.isInputEmpty(inputString)) {
                // reset error, no string means no error
                if (isValueControlled) {
                    // This should clear the date out for the consumer
                    nextState = Object.assign({}, nextState, {
                        inputString: this.getFormattedDateString(value, this.props, locale)
                    });
                } else {
                    // Uncontrolled
                    // should clear the input string if the input is empty
                    nextState = Object.assign({}, nextState, {
                        inputString: null
                    });
                }
            } else if (!DateUtils.isDate(maybeNextDate)) {
                nextState = Object.assign({}, nextState, {
                    value: null
                });
            } else {
                nextState = Object.assign({}, nextState, {
                    inputString: null, // reset to null since this is a valid date and is set as selectedValue
                    value: maybeNextDate
                });
            }

            // Need to be able to account for consumer's onBlur methods for error checking
            if (this.props.onBlur) {
                this.props.onBlur(this.state.value);
            }

            this.setState(nextState);
        }
    }, {
        key: 'handleInputFocus',
        value: function handleInputFocus(e, locale) {
            var value = this.state.value;

            var isOpen = true;
            var currentInputString = this.getFormattedDateString(value, this.props, locale);

            // Close the DayPicker UI if both dates are selected
            // This implementation keeps focus on the last focused boundary
            if (this.state.wasLastFocusChangeDueToSelectingDate) {
                isOpen = false;
            }

            this.setState({
                inputString: currentInputString, // re-set this because it gets cleared when blurred
                isOpen: isOpen,
                isInputFocused: true
            });
        }

        // This method is used to close the calendar UI when the input is focused

    }, {
        key: 'handleInputOnKeydown',
        value: function handleInputOnKeydown(e) {
            var isTabPressed = e.which === 9; // Tab keycode
            var isDownArrowPressed = e.which === 40; // Down arrow keycode
            var isEnterKeyPressed = e.which === 13; // Enter keycode

            if (this.state.isOpen && isDownArrowPressed) {
                // prevent the default behavior of scrolling down
                e.preventDefault();
                // get first selectable day
                if (this.datepicker.current.querySelector(FIRST_SELECTABLE_DAY)) {
                    this.datepicker.current.querySelector(FIRST_SELECTABLE_DAY).focus();
                } else if (this.datepicker.current.querySelector(CURRENT_DATE)) {
                    this.datepicker.current.querySelector(CURRENT_DATE).focus();
                } else {
                    this.datepicker.current.querySelector(FIRST_DAY_IN_MONTH).focus();
                }
            }

            if (isTabPressed) {
                var isOpen = false;
                this.setState({ isOpen: isOpen });
            }

            if (!this.props.disabled && !this.state.isOpen && isEnterKeyPressed) {
                this.openDatePicker();
            }
            // else the default keystroke happen without side effects
        }

        // Date Util Functions

    }, {
        key: 'parseDate',
        value: function parseDate(dateString, locale) {
            if (dateString === this.props.edsContext.formatMessage('component.DateRangePicker.error.outOfRange') || dateString === this.props.edsContext.formatMessage('component.DateRangePicker.error.invalidDate')) {
                return null;
            }

            var _props = this.props,
                format = _props.format,
                parseDateProp = _props.parseDate;

            // Accounts for ISO formats and format prop
            // YYYY-MM-DD and MM/DD/YYYY and the consumer provided prop

            var newDate = parseDateProp(dateString, format, locale) || parseDateProp(dateString, 'MM/DD/YYYY', locale) || parseDateProp(dateString, 'YYYY-MM-DD', locale);

            return newDate === false ? new Date(undefined) : newDate;
        }
    }, {
        key: 'getFormattedDateString',
        value: function getFormattedDateString(date, props, locale) {
            if (date == null) {
                return '';
            } else if (!DateUtils.isDate(date)) {
                return props.edsContext.formatMessage('component.DateRangePicker.error.invalidDate');
            } else {
                return formatDate(date, props.format, locale);
            }
        }

        // ========
        // Helper Functions
        // ========

    }, {
        key: 'getDayPickerModifiers',
        value: function getDayPickerModifiers() {
            var value = this.state.value;


            var modifiers = Object.assign({ day: value }, this.props.modifiers);

            return modifiers;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this,
                _cn2,
                _cn3,
                _cn5,
                _cn6;

            var _props2 = this.props,
                edsContext = _props2.edsContext,
                classes = _props2.classes,
                idProp = _props2.id,
                ContainerProps = _props2.ContainerProps,
                size = _props2.size,
                format = _props2.format,
                disabled = _props2.disabled,
                error = _props2.error,
                required = _props2.required,
                fullWidth = _props2.fullWidth,
                readOnly = _props2.readOnly,
                label = _props2.label,
                placeholder = _props2.placeholder,
                InputProps = _props2.InputProps,
                InputLabelProps = _props2.InputLabelProps,
                FormControlPropsProp = _props2.FormControlProps,
                FormHelperTextProps = _props2.FormHelperTextProps,
                helperText = _props2.helperText,
                PopperProps = _props2.PopperProps,
                ClickAwayListenerProps = _props2.ClickAwayListenerProps,
                minDate = _props2.minDate,
                maxDate = _props2.maxDate,
                withMonthYearSelect = _props2.withMonthYearSelect,
                variant = _props2.variant,
                props = _objectWithoutProperties(_props2, ['edsContext', 'classes', 'id', 'ContainerProps', 'size', 'format', 'disabled', 'error', 'required', 'fullWidth', 'readOnly', 'label', 'placeholder', 'InputProps', 'InputLabelProps', 'FormControlProps', 'FormHelperTextProps', 'helperText', 'PopperProps', 'ClickAwayListenerProps', 'minDate', 'maxDate', 'withMonthYearSelect', 'variant']);

            var _state2 = this.state,
                isOpen = _state2.isOpen,
                value = _state2.value,
                isInputFocused = _state2.isInputFocused;

            // If no id is sent in, use uuid to make a unique one

            var id = idProp || this.uuid;

            var FormControlProps = FormControlPropsProp || {};
            FormControlProps.size = size;

            // Figure out DatePicker direction based passed in prop or from EDSContext's direction
            var dir = 'dir' in props ? props.dir : edsContext.dir;

            // EDSApplication-level locale
            var locale = edsContext.locale;

            var anchorEl = this.inputContainerRef.current;

            var modifiers = this.getDayPickerModifiers();

            var selectedDays = value;

            return React.createElement(
                'div',
                null,
                variant !== 'standalone' ? React.createElement(
                    ClickAwayListener,
                    Object.assign({
                        onClickAway: function onClickAway() {
                            return _this2.closeDatePicker();
                        }
                    }, ClickAwayListenerProps),
                    React.createElement(
                        'div',
                        Object.assign({
                            id: id + '-container',
                            className: cn(classes.container, _defineProperty({}, classes.inputContainerFullWidth, fullWidth))
                        }, ContainerProps),
                        React.createElement(
                            'div',
                            {
                                className: cn(classes.inputContainer, (_cn2 = {}, _defineProperty(_cn2, classes.inputContainerDisabled, disabled), _defineProperty(_cn2, classes.inputContainerError, error), _defineProperty(_cn2, classes.inputContainerFullWidth, fullWidth), _cn2)),
                                role: 'presentation',
                                onKeyDown: function onKeyDown(e) {
                                    return _this2.handleContainerKeyDown(e);
                                }
                            },
                            React.createElement(
                                FormControl,
                                Object.assign({
                                    id: id + '-form-control',
                                    disabled: disabled,
                                    error: error,
                                    fullWidth: fullWidth,
                                    ref: this.inputContainerRef,
                                    className: cn(classes.inputContainer, (_cn3 = {}, _defineProperty(_cn3, classes.inputContainerDisabled, disabled), _defineProperty(_cn3, classes.inputContainerFullWidth, fullWidth), _cn3)),
                                    readOnly: readOnly
                                }, FormControlProps),
                                React.createElement(
                                    InputLabel,
                                    Object.assign({
                                        id: id + '-input-label',
                                        htmlFor: id + '-input',
                                        classes: {
                                            formControl: cn(classes.inputLabelFormControl, _defineProperty({}, classes.smallInputLabel, size === 'small')),
                                            shrink: classes.inputLabelShrink
                                        },
                                        disabled: disabled,
                                        error: error,
                                        required: required
                                    }, InputLabelProps),
                                    label
                                ),
                                React.createElement(Input, Object.assign({
                                    autoComplete: 'off',
                                    inputRef: this.inputRef,
                                    id: id + '-input',
                                    classes: {
                                        root: cn(classes.inputRoot, (_cn5 = {}, _defineProperty(_cn5, classes.inputFocused, isInputFocused || isOpen), _defineProperty(_cn5, classes.inputFocusedError, error), _defineProperty(_cn5, classes.smallDatePickerInput, size === 'small'), _cn5)),
                                        focused: classes.focused,
                                        input: classes.input,
                                        disabled: classes.inputDisabled
                                    },
                                    disableUnderline: true,
                                    value: this.getInputDisplayString(locale),
                                    placeholder: placeholder,
                                    readOnly: readOnly
                                }, InputProps, {
                                    onClick: function onClick(e) {
                                        return _this2.handleInputClick(e, locale);
                                    },
                                    onChange: function onChange(e) {
                                        return _this2.handleInputChange(e, locale);
                                    },
                                    onFocus: function onFocus(e) {
                                        return _this2.handleInputFocus(e, locale);
                                    },
                                    onBlur: function onBlur(e) {
                                        return _this2.handleInputBlur(e, locale);
                                    },
                                    onKeyDown: function onKeyDown(e) {
                                        return _this2.handleInputOnKeydown(e);
                                    },
                                    endAdornment: React.createElement(
                                        InputAdornment,
                                        { classes: {
                                                root: cn(classes.inputAdornment, (_cn6 = {}, _defineProperty(_cn6, classes.disabled, disabled), _defineProperty(_cn6, classes.smallDatePicker, size === 'small'), _cn6))
                                            }
                                        },
                                        React.createElement(CalendarIcon, null)
                                    ),
                                    'aria-describedby': id + '-dateDescription'
                                }))
                            ),
                            React.createElement(
                                Typography,
                                { variant: 'srOnly', id: id + '-dateDescription' },
                                this.props.edsContext.formatMessage('component.DayPicker.navDescription')
                            )
                        ),
                        helperText && React.createElement(
                            FormHelperText,
                            Object.assign({
                                disabled: disabled,
                                error: error
                            }, FormHelperTextProps),
                            helperText
                        ),
                        React.createElement(
                            'div',
                            { ref: this.datepicker },
                            React.createElement(
                                Popper,
                                Object.assign({
                                    id: id + '-popper',
                                    open: isOpen,
                                    anchorEl: anchorEl,
                                    className: classes.popper,
                                    placement: 'bottom-start',
                                    onKeyDown: function onKeyDown(e) {
                                        return _this2.handleContainerKeyDown(e);
                                    },
                                    disablePortal: true,
                                    modifiers: {
                                        flip: {
                                            enabled: false
                                        }
                                    }
                                }, PopperProps),
                                React.createElement(DayPicker, Object.assign({
                                    id: id,
                                    className: cn('hedtech-DatePicker', classes.DatePickerRoot),
                                    parse: parseDate,
                                    numberOfMonths: 1,
                                    selectedDays: selectedDays,
                                    modifiers: modifiers,
                                    format: format,
                                    locale: locale,
                                    dir: dir,
                                    localeUtils: MomentLocaleUtils,
                                    fromMonth: minDate,
                                    toMonth: maxDate,
                                    withMonthYearSelect: withMonthYearSelect
                                }, props, {
                                    onDayClick: this.handleOnDayClick,
                                    onDayMouseEnter: function onDayMouseEnter(day, dayModifiers) {
                                        return _this2.handleDayMouseEnter(day, dayModifiers, locale);
                                    },
                                    onDayMouseLeave: this.handleDayMouseLeave,
                                    onBlur: function onBlur(e) {
                                        // Following condition would validate whether focus is still on the calendar or not.  If not, it will close the calendar.
                                        // e.relatedTarget : This would help us to get the current focus item from the DOM.
                                        if (!e.currentTarget.contains(e.relatedTarget)) {
                                            _this2.closeDatePicker();
                                        }
                                    }
                                }))
                            )
                        )
                    )
                ) : React.createElement(DayPicker, Object.assign({
                    id: id,
                    className: cn('hedtech-DatePicker', classes.DatePickerRoot),
                    parse: parseDate,
                    numberOfMonths: 1,
                    selectedDays: selectedDays,
                    modifiers: modifiers,
                    format: format,
                    locale: locale,
                    dir: dir,
                    localeUtils: MomentLocaleUtils,
                    fromMonth: minDate,
                    toMonth: maxDate
                }, props, {
                    onDayClick: this.handleOnDayClick
                }))
            );
        }
    }]);

    return DatePicker;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.getInitialOpenState = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
        var isOpen = props.isOpen;

        if (isOpen != null) {
            return isOpen;
        } else {
            return false;
        }
    };

    this.getInitialDate = function () {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
        var defaultValue = props.defaultValue,
            value = props.value;

        if (value != null) {
            return value;
        } else if (defaultValue != null) {
            return defaultValue;
        } else {
            return null;
        }
    };

    this.openDatePicker = function () {
        // If calendar ui is already open, exit
        if (_this3.state.isOpen) {
            return;
        }

        _this3.setState({ isOpen: true });
    };

    this.closeDatePicker = function () {
        // If calendar ui is already closed, exit
        if (!_this3.state.isOpen) {
            return;
        }
        _this3.setState({
            isOpen: false,
            hoverString: null
        });
    };

    this.handleInputClick = function (e) {
        if (!_this3.props.disabled && !_this3.state.isOpen) {
            _this3.openDatePicker();
        }
    };

    this.handleContainerKeyDown = function (event) {
        if (event.key !== 'Escape') {
            return;
        }

        if (event.key === 'Escape') {
            _this3.inputRef.current.focus();
        }

        _this3.closeDatePicker();
    };

    this.isControlled = function () {
        return _this3.props.value !== undefined;
    };

    this.isInputEmpty = function (inputString) {
        return !inputString || inputString == null || inputString.length === 0;
    };
};

DatePicker.propTypes = {
    /**
     * @ignore
     * This function fetches resource string translations. It comes from the withEDSContext HOC.
     */
    edsContext: PropTypes.object,
    /**
     * @ignore
     * Helper variable for testing.
     */
    isOpen: PropTypes.bool,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * Properties applied to the top-level `div` element.
     */
    ContainerProps: PropTypes.object,

    // Generic props
    /**
     * The id of the `input` element. This is also used to create id's for internal components such as the the `FormControl`, `InputLabel` and `DayPicker`.
     *
     * - `div` (parent container) - `${id}-container`
                * - `FormControl` - `${id}-form-control`
                * - `InputLabel` - `${id}-input-label`
                * - `Input` - `${id}-input`
                * - `Popper` - `${id}-popper`
                */
    id: PropTypes.string,
    /**
     * The format of the date to accept and display.
     *
     * e.g. `M/D/YYYY`, `MM-D-YY`, `l`, `LL`, `ll`.
     */
    format: PropTypes.string,
    /**
     * If `true`, the input will take up the full width of its container.
     *
     * **Only valid when `variant="text-field"`.**
     */
    fullWidth: PropTypes.bool,
    /**
     * Callback fired when the value is changed. This function sends back a `Date`: (date) => setDates(date).
     * If no days are selected, it will pass `null`. Use this prop for controlled implementations.
     */
    onChange: PropTypes.func,
    /**
     * The value of the input represented via `Date` or string of a date. Use this prop for controlled implementations.
     *
     * **Only valid when `variant="text-field"`.**
     */
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),

    /**
     * The `Date` value for uncontrolled implementations.
     */
    defaultValue: PropTypes.instanceOf(Date),
    /**
     * If `true`, the label is displayed as required.
     *
     * **Only valid when `variant="text-field"`.**
     */
    required: PropTypes.bool,
    /**
     * The maximum date possible to select. The selected date must fall in between the `minDate` and `maxDate`. Default is December 31st, 10 years in the future.
     */
    maxDate: PropTypes.any,
    /**
     * The minimum date possible to select. The selected date must fall in between the `minDate` and `maxDate`. Default is January 1st, 20 years in the past.
     */
    minDate: PropTypes.any,
    /**
     * Custom date function that parses the date. This is used to display date to the user in the input field.
     *
     * e.g.
     *
     * `(dateString: string, format: string, locale: string) => string`
     */
    parseDate: PropTypes.func,
    /**
     * If `true`, the next/previous buttons are replaced with month/year dropdowns.
     */
    withMonthYearSelect: PropTypes.bool,
    /**
     * The first year in the year selection dropdown. Only applies when `withMonthYearSelect` is `true`.
     */
    startYear: PropTypes.number,
    /**
     * The last year in the year selection dropdown. Only applies when `withMonthYearSelect` is `true`.
     */
    endYear: PropTypes.number,

    // DayPicker props
    /**
     * The month to display in the calendar at first render.
     */
    initialMonth: PropTypes.instanceOf(Date),
    /**
     * @ignore
     *
     * Labels to use as `aria-label` HTML attributes for the previous and next month navigation buttons.
     */
    labels: PropTypes.object,
    /**
     * @ignore
     *
     * Object of functions to format dates and to get the first day of the week. You can pass your own object for advanced [localization](http://react-day-picker.js.org/docs/localization/).
     */
    localeUtils: PropTypes.object,
    /**
     * @ignore
     * An object of *day modifiers*. This will add a new CSS class name on the days that match the modifier. [View react-day-picker documentation](http://react-day-picker.js.org/docs/matching-days/).
     *
     * e.g.
     * `const modifiers = {birthday: new Date(2018, 8, 19) } => // Creates a day component with the class name: .DayPicker-Day--birthday`
                */
    modifiers: PropTypes.object,
    /**
     * @ignore
     * An object of inline styles added to the day cells when a modifier is matched. Use this prop to style day cells inline instead of using CSS classes.
     */
    modifiersStyles: PropTypes.object,
    /**
     * @ignore
     *
     * The month to display in the calendar. This differs from the `initialMonth` prop, as it causes the calendar to re-render when its value changes.
     */
    month: PropTypes.instanceOf(Date),
    /**
     * An array containing the long month names to use in the month’s header. Defaults to the English month names.
     */
    months: PropTypes.arrayOf(PropTypes.string),

    /**
     * @ignore
     *
     * A React Element or React Component to render the navigation bar. It will receive the following props:
     *
     * - month: Date The currently displayed month
     * - previousMonth: Date
     * - nextMonth: Date
     * - onPreviousClick: () ⇒ void
     * - onNextClick: () ⇒ void
     */
    navbarElement: PropTypes.arrayOf(PropTypes.string),

    /**
     * @ignore
     *
     * The number of months to render.
     *
     * We recommend this prop to be using sparingly. In some situations,
     * where only one month should be shown to conserve screen space or issues arise with the visual layout
     * of the DatePicker calendar interface. Most common situations are when the `DatePicker` is
     * placed in a `Dialog` or `Table`.
     */
    numberOfMonths: PropTypes.number,

    /**
     * @ignore
     *
     * When displaying multiple months, navigation will be paginated displaying the `numberOfMonths` at time instead of one.
     */
    pagedNavigation: PropTypes.bool,

    /**
     * @ignore
     *
     * Returns the content of a day cell. As default it returns day’s current date.
     */
    renderDay: PropTypes.oneOfType([PropTypes.elementType, PropTypes.func]),
    /**
     * @ignore
     *
     * Returns the content of the week element when showWeekNumbers is set. As default it returns the week number.
     */
    renderWeek: PropTypes.func,

    /**
     * Day(s) that should appear as selected.
     */
    selectedDays: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.object, PropTypes.arrayOf(PropTypes.instanceOf(Date)), PropTypes.func]),
    /**
     * Day(s) that should appear as disabled.
     */
    disabledDays: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.object, PropTypes.arrayOf(PropTypes.instanceOf(Date)), PropTypes.func]),

    /**
     * Highlight today's date in the calendar.
     */
    highlightToday: PropTypes.bool,

    /**
     * @ignore
     * Display the days falling outside the current month.
     */
    showOutsideDays: PropTypes.bool,
    /**
     * @ignore
     * Display the weekday names in the calendar header.
     */
    showWeekDays: PropTypes.bool,
    /**
     * @ignore
     * Display the year's week number next to each week.
     */
    showWeekNumbers: PropTypes.bool,
    /**
     * @ignore
     * Display a button to switch to the current month using the provided string as a label.
     */
    todayButton: PropTypes.bool,
    /**
     * Render the `DatePicker` with input field or as a standalone calendar UI.
     *
     * Options:
     *
     * * 'text-field'
     * * 'standalone'
     *
     */
    variant: PropTypes.oneOf(['text-field', 'standalone']),
    /**
     * @ignore
     *
     * A React Element or React Component to render the weekday cells in the header. It will receive the following props:
     *
     * - weekday `number`
     * - className `string`
     * - localeUtils `object`
     * - locale `string`
     */
    weekdayElement: PropTypes.instanceOf(Date),
    /**
     * @ignore
     *
     * An array containing the long weekdays names to use in the month's header Defaults to the English weekdays names. Must start from Sunday.
     */
    weekdaysLong: PropTypes.arrayOf(PropTypes.string),
    /**
     * @ignore
     *
     * An array containing the short weekdays names to use in the month's header. Defaults to the English weekdays names. Must start from Sunday.
     */
    weekdaysShort: PropTypes.arrayOf(PropTypes.string),

    // DayPicker EventHandlers
    /**
     * @ignore
     */
    onCaptionClick: PropTypes.func,

    /**
     * Event handler when the input gets the `blur` event.
     *
     * e.g.
     * (e: SyntheticEvent) ⇒ void
     */
    onBlur: PropTypes.func,

    /**
     * @ignore
     *
     * Event handler when the user clicks on a day cell.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayClick: PropTypes.func,
    /**
     * @ignore
     *
     * Event handler when the day cell gets the `keydown` event.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayKeyDown: PropTypes.func,
    /**
     * @ignore
     *
     * Event handler when the day cell gets the `focus` event.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayFocus: PropTypes.func,
    /**
     * @ignore
     ** Event handler when the mouse button is pressed on a day cell.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayMouseDown: PropTypes.func,
    /**
     * @ignore
     * Event handler when the mouse enters a day cell.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayMouseEnter: PropTypes.func,
    /**
     * @ignore
     * Event handler when the mouse leave a day cell.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayMouseLeave: PropTypes.func,
    /**
     * @ignore
     *
     * Event handler when the mouse button is released on a day cell.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayMouseUp: PropTypes.func,

    /**
     * @ignore
     *
     * Event handler when the day cell gets the `touchStart` event.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayTouchStart: PropTypes.func,
    /**
     * @ignore
     *
     * Event handler when the day cell gets the `touchEnd` event.
     *
     * e.g.
     * `(day: date, modifiers: Object, e: SyntheticEvent) ⇒ void`
     */
    onDayTouchEnd: PropTypes.func,

    /**
     * @ignore
     *
     * Event handler when the month is changed, i.e. clicking the navigation buttons or using the keyboard.
     *
     * e.g.
     * `(month: date) ⇒ void`
     */
    onMonthChange: PropTypes.func,

    /**
     * @ignore
     */
    onWeekClick: PropTypes.func,
    /**
     * @ignore
     */
    onTodayButtonClick: PropTypes.func,

    // Public Methods
    /**
     * @ignore
     */
    showMonth: PropTypes.func,
    /**
     * @ignore
     */
    showPreviousMonth: PropTypes.func,
    /**
     * @ignore
     */
    showNextMonth: PropTypes.func,
    /**
     * @ignore
     */
    showPreviousYear: PropTypes.func,
    /**
     * @ignore
     */
    showNextYear: PropTypes.func,

    // Input/FormControl props
    /**
     * If `true`, the input field will be displayed in an error state.
     *
     * **Only valid when `variant="text-field"`.**
     */
    error: PropTypes.bool,
    /**
     * If `true`, the input will be disabled.
     *
     * **Only valid when `variant="text-field"`.**
     */
    disabled: PropTypes.bool,
    /**
     * If `true`, the input will be readOnly. Users will not be able to type a date into the input field.
     *
     * **Only valid when `variant="text-field"`.**
     */
    readOnly: PropTypes.bool,
    /**
     * The label for the input.
     *
     * **Only valid when `variant="text-field"`.**
     */
    label: PropTypes.string,
    /**
     * The placeholder text for the start input.
     *
     * **Only valid when `variant="text-field"`.**
     */
    placeholder: PropTypes.string,
    /**
     * The size of the text field. Small size is recommended to be used within the `TableEditableCell` component.
     * **Only valid when `variant="text-field"`.**
     */
    size: PropTypes.oneOf(['small', 'medium']),
    /**
     * Properties applied to the start [`Input`](https://material-ui.com/api/input/#input-api) element.
     * If you re-assign the `placeholder` property, it will override the `placeholder` prop.
     *
     * **Only valid when `variant="text-field"`.**
     */
    InputProps: PropTypes.object,
    /**
     * Properties applied to the start [`InputLabel`](#/components/FormControl) element.
     *
     * **Only valid when `variant="text-field"`.**
     */
    InputLabelProps: PropTypes.object,

    /**
     * Properties applied to the [`FormControl`](#/components/FormControl) element.
     *
     * **Only valid when `variant="text-field"`.**
     */
    FormControlProps: PropTypes.object,

    // Popper props
    /**
     * Properties applied to the [`Popper`](#/components/Popper) element.
     *
     * **Only valid when `variant="text-field"`.**
     */
    PopperProps: PropTypes.object,

    /**
     * Properties applied to the [`ClickAwayListener`](https://material-ui.com/api/click-away-listener/) element.
     *
     * **Only valid when `variant="text-field"`.**
     */
    ClickAwayListenerProps: PropTypes.object,

    // FormHelperText props
    /**
     * The helper text content.
     *
     * **Only valid when `variant="text-field"`.**
     */
    helperText: PropTypes.string,
    /**
     * Properties applied to the [`FormHelperText`](#/components/FormControl) element.
     *
     * **Only valid when `variant="text-field"`.**
     */
    FormHelperTextProps: PropTypes.object
};

DatePicker.defaultProps = {
    initialMonth: new Date(),
    format: 'L',
    showOutsideDays: true,
    maxDate: getDefaultMaxDate(),
    minDate: getDefaultMinDate(),
    InputProps: {},
    parseDate: parseDate,
    highlightToday: true,
    variant: 'text-field',
    size: 'medium'
};

export default withEDSContext(withStyles(styles)(DatePicker));